// The WhatsApp contact pickers - the phone box of SendLinkViaWhatsappModal (שליחת קישור בוואטסאפ) and
// הודעה חדשה in HeaderWhatsappBox - search customers with /search-results/?term= and list PEOPLE, not
// rows: a row is an event, so a customer with several events comes back several times, a couple
// comes back as one row with two people, and only someone with a phone can get a WhatsApp.
//
// Every person of the rows is listed. The pickers stopped at 7 / 8, so with a name many customers
// share most of them never showed. The people whose name or phone holds a word of the search come
// first, in the api's order (best match first); then the others of those rows - the partner in a
// couple, everyone of a row that matched by its event name / place - in the same order.
//
// words - the api's `words`: the search split into words, as the api matched them
// options.byContactId - one suggestion per contact id, and only contacts that have one (the header
//   box opens the conversation by contact id). Otherwise one per name + number, and a lead row with
//   no contacts json falls back to its flat contactNames / phones columns (the link modal only
//   needs the number).
export function contactSuggestions(results, words, options) {

    options = options || {};

    const searchWords = (words || []).map(word => String(word).trim().toLowerCase()).filter(word => word.length);
    const matched = [];
    const others = [];
    const seen = {};

    for (let i = 0; i < (results || []).length; i++) {

        const result = results[i];
        let contacts = result.contactsDisplayJson;

        if (typeof contacts === 'string') {
            try { contacts = JSON.parse(contacts); } catch (e) { contacts = null; }
        }

        if (!contacts || !contacts.length) {

            if (options.byContactId)
                continue;

            // Lead-shape rows have no contacts json — fall back to the flat columns
            const phone = String(result.phones || '').split(' | ')[0];
            contacts = phone ? [{ firstName: result.contactNames, lastName: '', pic: null, phone: phone }] : [];
        }

        for (let j = 0; j < contacts.length; j++) {

            const contact = contacts[j];

            if (!contact || !contact.phone || (options.byContactId && !contact.id))
                continue;

            const name = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || result.contactNames || '';
            const key = options.byContactId ? String(contact.id) : name + '|' + String(contact.phone).replace(/\D/g, '');

            if (seen[key])
                continue;

            seen[key] = true;

            const suggestion = {
                key: key,
                id: contact.id || null,
                name: name,
                phone: contact.phone,
                pic: contact.pic || null,
            };

            (holdsSearchWord(name, contact.phone, searchWords) ? matched : others).push(suggestion);
        }
    }

    return matched.concat(others);
}

// The line above the list: how many were found (the list scrolls, so the count says what is below),
// or - when the api had more rows than it sends (`more`) - that these are the first ones.
export function contactSuggestionsLine(count, more) {

    if (more)
        return 'מוצגים ' + count + ' אנשי הקשר הראשונים - הקלידו עוד כדי לצמצם';

    return count == 1 ? 'נמצא איש קשר אחד' : 'נמצאו ' + count + ' אנשי קשר';
}

// a name that holds a word, or a phone whose digits hold a word made of digits
function holdsSearchWord(name, phone, words) {

    const lowerName = String(name).toLowerCase();
    const digits = String(phone).replace(/\D/g, '');

    for (let i = 0; i < words.length; i++) {

        if (lowerName.indexOf(words[i]) >= 0)
            return true;

        if (/^\d+$/.test(words[i]) && digits.indexOf(words[i]) >= 0)
            return true;
    }

    return false;
}
